import { Rating, Stack, Tooltip, Typography, styled } from "@mui/material";
import { HpIcon } from "../_/components/icons/Icons";
import { CharacterStats } from "./Stats";
import { Row } from "../_/components/organization";

export const Hp = ({ stats }: { stats: CharacterStats }) => {

    return (
        <Tooltip title={`Punkty życia`}>
            <Row>
                {/* <Typography component="legend" align="center">Życie</Typography> */}
                <HpIcon fontSize="large" />
                <Typography component="legend" align="center" fontSize={"28px"}>{stats.hp}</Typography>
            </Row>
        </Tooltip >
    )
}

const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#ff6d75',
    },
    '& .MuiRating-iconHover': {
        color: '#ff3d47',
    },
});